import { DocumentTypeEnum } from "@jnext/ts-axios-reward";
import { JCmsFieldDTO, JFieldDTO, JFieldDTOType } from "../JFormCompositor";
import { EMAIL_BASE64_VALIDATION_FUNCTION, makeValidationFunction } from "../lib/utils/validators";
import { RedemptionFieldDTO, RedemptionFieldsHurlIds } from "../models/RedemptionForm";

export class RedemptionField implements RedemptionFieldDTO {
    cmsConfig!: JCmsFieldDTO
    type!: JFieldDTOType
    hurlId!: RedemptionFieldsHurlIds
    mandatory = true
    children?: JFieldDTO[]
    values?: string[]
    username = false
    validationFunction?: string
    overrideValue?: string
    constructor(hurlId: RedemptionFieldsHurlIds, translationPrefix: string) {
        this.hurlId = hurlId
        this.cmsConfig = {
            title: `${translationPrefix}_TITLE`,
            text: `${translationPrefix}_TEXT`,
            placeholder: `${translationPrefix}_TITLE`,
            additionalText: `${translationPrefix}_ADDITIONALTEXT`,
            order: 1,
            componentConfig: {
                options: [],
            }
        }
        switch (hurlId) {
            case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_PROVINCE:
            case RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_PROVINCE:
                this.type = 'JTEXT'
                this.validationFunction = makeValidationFunction('PROVINCE')
                break;
            case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_COUNTRY:
                this.type = 'JCOUNTRY'
                break;
            case RedemptionFieldsHurlIds.PERSONAL_DATA_BIRTH_DATE:
                this.type = 'JDATE'
                break;
            case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_POSTAL_CODE:
            case RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_POSTAL_CODE:
                this.type = 'JTEXT'
                this.validationFunction = makeValidationFunction('CAP')
                break;
            case RedemptionFieldsHurlIds.DELIVERY_EMAIL:
            case RedemptionFieldsHurlIds.PERSONAL_DATA_EMAIL:
                this.type = 'JEMAIL'
                this.validationFunction = EMAIL_BASE64_VALIDATION_FUNCTION
                break;
            case RedemptionFieldsHurlIds.PERSONAL_DATA_PHONE:
            case RedemptionFieldsHurlIds.DELIVERY_PHONE:
                this.type = 'JPHONE'
                break;
            case RedemptionFieldsHurlIds.DELIVERY_USE_PERSONAL_DATA:
                this.type = 'JCHECKBOX'
                this.mandatory = false
                this.cmsConfig.componentConfig.options = [
                    {
                        value: 'true',
                        label: {
                            title: `${translationPrefix}_OPTION_TRUE_TITLE`
                        }
                    }
                ]
                break;
            case RedemptionFieldsHurlIds.APPROVAL_REJECT:
                this.type = 'JCHECKBOX'
                this.mandatory = false
                this.cmsConfig.componentConfig.options = [
                    {
                        value: 'true',
                        label: {
                            title: `${translationPrefix}_OPTION_REJECT_TITLE`
                        }
                    }
                ]
                break;
            case RedemptionFieldsHurlIds.APPROVAL_ACCEPT:
                this.mandatory = false
                this.type = 'JCHECKBOX'
                this.cmsConfig.componentConfig.options = [
                    {
                        value: 'true',
                        label: {
                            title: `${translationPrefix}_OPTION_ACCEPT_TITLE`
                        }
                    }
                ]
                break;
            case RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_TYPE:
                this.mandatory = true
                this.type = 'JSELECT'
                this.cmsConfig.componentConfig.options = Object.values(DocumentTypeEnum).map(value => ({
                    value,
                    label: {
                        title: `${translationPrefix}_OPTION_${value}_TITLE`
                    }
                }))
                break
            case RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_FILES:
                this.mandatory = true
                this.type = 'JFILE'
                this.cmsConfig.colConfig = {
                    span: 24
                }
                this.cmsConfig.componentConfig.accept = 'image/jpeg,image/gif,image/png,application/pdf,image/x-eps'
                this.cmsConfig.componentConfig.multiple = true
                this.cmsConfig.componentConfig.maxCount = 2
                this.cmsConfig.componentConfig.maxSize = 2097152
                break;
            case RedemptionFieldsHurlIds.DELIVERY_NOTE:
                this.mandatory = false
                this.type = 'JTEXTAREA'
                break;
            default:
                this.type = 'JTEXT'
                break;
        }
    }
}
function generateFields() {
    const fields: RedemptionFieldDTO[] = []
    for (const [key, hurlId] of Object.entries(RedemptionFieldsHurlIds)) {
        fields.push(new RedemptionField(hurlId, `REDEMPTION_FIELD_${key}`))
    }
    return fields
}

export const REDEMPTION_FIELDS: RedemptionFieldDTO[] = generateFields()
export const REDEMPTION_FIELDS_WITH_VALUES: RedemptionFieldDTO[] = generateFields().map(withValues)


export function withValues(field: RedemptionField) {
    switch (field.hurlId) {

        case RedemptionFieldsHurlIds.DELIVERY_EMAIL:
            field.values = ['gianmaria.mennuto@circlegarage.com']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_NAME:
            field.values = ['gianmaria']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_SURNAME:
            field.values = ['mennuto']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_STREET:
            field.values = ['via degli abeti']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_POSTAL_CODE:
            field.values = ['16166']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_CITY:
            field.values = ['genova']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_PROVINCE:
            field.values = ['GE']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_ADDRESS_COUNTRY:
            field.values = ['IT']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_NOTE:
            field.values = ['Nota']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_NAME:
            field.values = ['gianmaria']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_SURNAME:
            field.values = ['mennuto']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_BIRTH_PLACE:
            field.values = ['genova']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_BIRTH_DATE:
            field.values = [new Date().toISOString().split('T')[0]]
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_STREET:
            field.values = ['via dei cipressi']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_POSTAL_CODE:
            field.values = ['15555']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_CITY:
            field.values = ['genova']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_ADDRESS_PROVINCE:
            field.values = ['GE']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_EMAIL:
            field.values = ['gianmaria.mennuto@circlegarage.com']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_PHONE:
            field.values = ['+39 3333333333']
            break;
        case RedemptionFieldsHurlIds.DELIVERY_PHONE:
            field.values = ['+33 3333333333']
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_TYPE:
            field.values = [DocumentTypeEnum.IdCard]
            break;
        case RedemptionFieldsHurlIds.PERSONAL_DATA_DOCUMENT_NUMBER:
            field.values = ['123123123']
            break;
        default:
            break;
    }
    return field
}